import { Box, Fade, Modal, ModalProps } from "@mui/material";

interface BaseModalProps {
  handleClose: () => void;
  width?: number | string;
}
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  borderRadius: "10px",
  padding: "2rem",
  maxWidth: "80%",
  maxHeight: "80%",
  minWidth: "500px",
};

export const BaseModal = ({
  handleClose,
  children,
  width,
  ...props
}: BaseModalProps & ModalProps) => {
  return (
    <Modal {...props} onClose={handleClose}>
      <Fade in={props.open}>
        <Box sx={width ? { ...modalStyle, width } : modalStyle}>{children}</Box>
      </Fade>
    </Modal>
  );
};
